<template>
  <div id="modemForm">
    <div class="common_tit_wrap">
      <div class="common_page_tit">모뎀 현황
        <template v-if="modemPid != null">기존 모뎀 수정</template>
        <template v-else>신규 모뎀 등록</template>
      </div>
    </div>
    <div class="common_form_wrap">
      <div class="common_form_box">
        <div class="common_form_box_tit">모뎀 기본정보</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap half_width">
            <label>가입대리점코드</label>
            <div><input type="text" :value="affiliatedDealerCode" readonly/></div>
          </div>
          <div class="common_form_input_wrap half_width">
            <label>사업자번호</label>
            <div><input type="text" :value="businessNumber" readonly/></div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap half_width">
            <label>가입번호<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="registryNum"/>
            </div>
          </div>
          <div class="common_form_input_wrap half_width"></div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap half_width">
            <label>이동전화번호<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="mobileNum"/>
            </div>
          </div>
          <div class="common_form_input_wrap half_width">
            <label>모델명</label>
            <div>
              <input type="text" v-model="modelName"/>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap half_width">
            <label>USIM<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="usim"/>
            </div>
          </div>
          <div class="common_form_input_wrap half_width">
            <label>SN</label>
            <div>
              <input type="text" v-model="serialNum"/>
            </div>
          </div>
        </div>
<!--        <div class="common_form_box_content">-->
<!--          <div class="common_form_input_wrap half_width">-->
<!--            <label>IMEI<span class="fc_red">*</span></label>-->
<!--            <div>-->
<!--              <input type="text" v-model="imei"/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="common_form_box">
        <div class="common_form_box_tit">모뎀 사업정보</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap quarter3_width">
            <label>소속</label>
            <div>
              <select v-model="affiliateCode">
                <option value="">미선택</option>
                <option v-for="item in afcList" :key="'afc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
              <select v-model="ofc1Select" @change="getOfc2List(ofc1Select, true)">
                <option value="">미선택</option>
                <option v-for="item in ofc1List" :key="'ofc1_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
              <select v-model="ofc2Select">
                <option value="">미선택</option>
                <option v-for="item in ofc2List" :key="'ofc2_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap one_third_width">
            <label>사업구분<span class="fc_red">*</span></label>
            <div>
              <select v-model="projectType">
                <option value="">미선택</option>
                <option v-for="item in prtList" :key="'prt_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
          </div>
          <div class="common_form_input_wrap one_third_width">
            <label>구축구분<span class="fc_red">*</span></label>
            <div>
              <select v-model="structType">
                <option value="">미선택</option>
                <option v-for="item in sttList" :key="'stt_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap quarter1_width">
            <label>납품일</label>
            <div>
              <vue-datepicker-local
                v-model="supplyDate"
                inputClass="vdl_input"
                :local="ko"/>
            </div>
          </div>
          <div class="common_form_input_wrap quarter1_width">
            <label>개통일</label>
            <div>
              <vue-datepicker-local
                v-model="connectedDate"
                inputClass="vdl_input"
                :local="ko"/>
            </div>
          </div>
          <div class="common_form_input_wrap quarter1_width">
            <label>등록일</label>
            <div>
              <vue-datepicker-local
                v-model="registerDate"
                inputClass="vdl_input"
                :local="ko"/>
            </div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <div class="btn_bottom btn_blue" @click="saveModem">저장</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import common from '../../script/common'
import modemInfo from '../../script/modemInfo'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDatepickerLocal},
  data () {
    return {
      affiliatedDealerCode: common.getAffiliatedDealerCode(),
      businessNumber: common.getBusinessNumber(),
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      // Return
      searchParams: {},
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc1Select: '',
      ofc2List: [],
      ofc2Select: '',
      prtList: [],
      sttList: [],
      // Modem
      originData: {},
      modemPid: null,
      registryNum: '',
      mobileNum: '',
      modelName: '',
      usim: '',
      serialNum: '',
      // imei: '',
      affiliateCode: '',
      officeCode: '',
      projectType: '',
      structType: '',
      supplyDate: '',
      connectedDate: '',
      registerDate: ''
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            if (this.$route.params != null && this.$route.params.type != null && this.$route.params.type === 'edit') {
              this.updateData()
              if (this.$route.params.searchParams != null) {
                this.searchParams = this.$route.params.searchParams
              }
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    mobileNum () {
      this.mobileNum = this.mobileNum.replace(/[^0-9]/g, '')
    }
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List (ofc, isSelect) {
      if (isSelect) {
        this.ofc2List = this.ofcList.filter(item => { return item.codeParent === ofc })
      } else {
        return this.ofcList.filter(item => { return item.codeParent === ofc })
      }
    },
    updateData () {
      this.originData = this.$route.params.data
      const data = this.$route.params.data
      if (!data.hasOwnProperty('modemPid') || data.modemPid == null) {
        return
      }
      this.modemPid = data.modemPid
      this.registryNum = data.registryNum != null ? data.registryNum : ''
      this.mobileNum = data.mobileNum != null ? data.mobileNum : ''
      this.modelName = data.modelName != null ? data.modelName : ''
      this.usim = data.usim != null ? data.usim : ''
      this.serialNum = data.serialNum != null ? data.serialNum : ''
      // this.imei = data.imei != null ? data.imei : ''
      this.affiliateCode = data.affiliateCode != null ? data.affiliateCode : ''
      if (data.officeCode != null && data.officeCode.length > 0) {
        this.ofc1Select = data.officeCode.substring(0, 5)
        this.ofc2Select = ''
        this.getOfc2List(this.ofc1Select.substring(0, 5), true)
        if (data.officeCode.length > 5) {
          this.ofc2Select = data.officeCode
        }
      }
      this.projectType = data.projectType != null ? data.projectType : ''
      this.structType = data.structType != null ? data.structType : ''
      this.supplyDate = data.supplyDate != null ? new Date(data.supplyDate) : ''
      this.connectedDate = data.connectedDate != null ? new Date(data.connectedDate) : ''
      this.registerDate = data.registerDate != null ? new Date(data.registerDate) : ''
    },
    saveModem () {
      if ((this.mySession.subRole & 1) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      if (!common.checkValidateData('string', this.registryNum) ||
        !common.checkValidateLength('max', this.registryNum, 64)) {
        common.amsAlert('general', '가입번호를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.mobileNum) ||
        !common.checkValidateLength('max', this.mobileNum, 15)) {
        common.amsAlert('general', '이동전화번호를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.usim) ||
        !common.checkValidateLength('max', this.usim, 20)) {
        common.amsAlert('general', 'USIM을 입력해주세요.')
        return
      }
      // if (!common.checkValidateData('string', this.imei) ||
      //   !common.checkValidateLength('max', this.imei, 20)) {
      //   common.amsAlert('general', 'IMEI를 입력해주세요.')
      //   return
      // }
      if (!common.checkValidateData('string', this.projectType)) {
        common.amsAlert('general', '사업구분을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.structType)) {
        common.amsAlert('general', '구축구분을 선택해주세요.')
        return
      }
      let data = {
        registryNum: this.registryNum,
        mobileNum: this.mobileNum,
        usim: this.usim,
        // imei: this.imei,
        projectType: this.projectType,
        structType: this.structType
      }
      if (common.checkValidateData('string', this.modelName)) {
        if (common.checkValidateLength('max', this.modelName, 20)) {
          data.modelName = this.modelName
        } else {
          common.amsAlert('general', '모델명이 너무 깁니다.')
          return
        }
      }
      if (common.checkValidateData('string', this.serialNum)) {
        if (common.checkValidateLength('max', this.serialNum, 20)) {
          data.serialNum = this.serialNum
        } else {
          common.amsAlert('general', 'SN이 너무 깁니다.')
          return
        }
      }
      if (common.checkValidateData('string', this.affiliateCode)) {
        data.affiliateCode = this.affiliateCode
      }
      if (common.checkValidateData('string', this.ofc1Select)) {
        data.officeCode = this.ofc1Select
        if (common.checkValidateData('string', this.ofc2Select)) {
          data.officeCode = this.ofc2Select
        }
      }
      if (common.checkValidateData('date', this.supplyDate)) {
        data.supplyDate = common.getFormattedDate(this.supplyDate)
      }
      if (common.checkValidateData('date', this.connectedDate)) {
        data.connectedDate = common.getFormattedDate(this.connectedDate)
      }
      if (common.checkValidateData('date', this.registerDate)) {
        data.registerDate = common.getFormattedDate(this.registerDate)
      }
      let method = 'put'
      const checkedData = common.checkChangedData(data, this.originData)
      if (this.modemPid != null) {
        method = 'post'
        if (Object.keys(checkedData).length > 0) {
          checkedData.modemPid = this.originData.modemPid
        } else {
          common.amsAlert('general', '수정된 내용이 없습니다.')
          return
        }
      }
      console.log(method, checkedData)
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemInfo.modemInfo(method, checkedData, response => {
        console.log('modemInfo: ' + method, response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '모뎀을 ' + (method === 'put' ? '등록' : '수정') + '했습니다.')
          vueLoadingOverlay.hide()
          this.$router.push({
            name: 'ModemList',
            params: {
              type: 'return',
              searchParams: this.searchParams
            }
          })
        } else if (response.data.resultCode === -50) {
          common.amsAlert('general', '이미 사용중인 이동전화번호입니다.')
          vueLoadingOverlay.hide()
        } else {
          common.amsAlert('retry', '모뎀을 ' + (method === 'put' ? '등록' : '수정') + '하지 못했습니다.')
          vueLoadingOverlay.hide()
        }
      })
    }
  }
}
</script>

<style scoped>
#modemForm {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

#modemForm .common_bottom_wrap > .btn_blue {
  margin: auto 0 auto auto;
}
</style>



// WEBPACK FOOTER //
// src/components/modemInfo/ModemForm.vue